import { render, staticRenderFns } from "./lands.vue?vue&type=template&id=45d76bd6&scoped=true&"
import script from "./lands.vue?vue&type=script&lang=js&"
export * from "./lands.vue?vue&type=script&lang=js&"
import style0 from "./lands.vue?vue&type=style&index=0&id=45d76bd6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d76bd6",
  null
  
)

export default component.exports